import { render } from "./JournalAnalysisModal.vue?vue&type=template&id=01688e37&scoped=true&ts=true"
import script from "./JournalAnalysisModal.vue?vue&type=script&lang=ts"
export * from "./JournalAnalysisModal.vue?vue&type=script&lang=ts"

import "./JournalAnalysisModal.vue?vue&type=style&index=0&id=01688e37&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01688e37"]])

export default __exports__